import { IconProps, Icon } from "@chakra-ui/react";

function PenIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.39686 15.0964C1.43515 14.7518 1.45429 14.5795 1.50642 14.4185C1.55268 14.2756 1.61802 14.1397 1.70069 14.0143C1.79388 13.873 1.91645 13.7504 2.1616 13.5053L13.1669 2.50005C14.0873 1.57957 15.5797 1.57957 16.5002 2.50005C17.4207 3.42052 17.4207 4.91291 16.5002 5.83338L5.49493 16.8386C5.24978 17.0838 5.12721 17.2063 4.9859 17.2995C4.86054 17.3822 4.72457 17.4475 4.5817 17.4938C4.42067 17.5459 4.24838 17.5651 3.9038 17.6033L1.0835 17.9167L1.39686 15.0964Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}

export default PenIcon;
